module.exports = __webpack_public_path__ + "img/2_uk.9656e860.svg";